
import _ from 'lodash'
export default class SessionFlow {

  static inst
  
  static get() {
    return SessionFlow.inst
  }

  static init(session, incentives, segments, widgets, orders, notificationDefs, accountTimezone) {
    SessionFlow.inst = new SessionFlow(session, incentives, segments, widgets, orders, notificationDefs, accountTimezone)
    return SessionFlow.inst
  }

  constructor(session, incentives, segments, widgets, orders, notificationDefs, accountTimezone) {
    this.session = session
    this.incentives = incentives
    this.segments = segments
    this.widgets = widgets
    this.orders = orders
    this.notificationDefs = notificationDefs
    this.accountTimezone = accountTimezone

    this.flow = []
    this.last_added_index = -1
    this.ab_page_index = 0
    this.total_matched_segments = 0
    this.userId = null
    this.siteDetails = ''
    this.ignoreUserUntil = null
    this.isIgnoring = false

    if (session.userSite) {
      const userSite = session.userSite
      this.userId = userSite.userId

      if (userSite.ignoreUserUntil) {
        const hxIgnoreUserUntil = userSite.ignoreUserUntil
        const until = this.hx_date_to_mysql_date(hxIgnoreUserUntil)
        this.ignoreUserUntil = this.hx_date_to_mysql_date(hxIgnoreUserUntil)
        const now = window.moment.tz(window.moment().utc(), 'UTC').tz(accountTimezone)
        if (now.isBefore(window.moment(until))) {
          this.isIgnoring = true
        }
      }
    }

    if (session) {
      this.start_time = this.hx_date_to_mysql_date(session.pages[0].visitTime)

      this.ab_page_index = parseInt(session.abPageIndex)

      this.process_pages()
    }
  }

  process_pages () {
    this.last_page = null;

    for ( let i = 0; i < this.session.pages.length; i++) {
      this.current_page = this.session.pages[i];

      this.session.pages[i].index = i;
      this.session.pages[i].timestamp = this.hx_date_to_mysql_date(this.session.pages[i].visitTime);


      if (this.is_order_reset_page(this.session.pages[i])) {
        let matchedOrder = null
        if (this.orders) {
          for (const order of this.orders) {
            if (order.orderNumber === this.session.pages[i].quoteId) {
              matchedOrder = order
              matchedOrder.createdOn = this.hx_date_to_mysql_date(matchedOrder.createdOn)
              matchedOrder.orderDate = this.hx_date_to_mysql_date(matchedOrder.orderDate)
              break;
            }
          }
        }
        this.betterAdd('order', { 
          order: matchedOrder,
          page: this.session.pages[i]
        })
      } else {
        this.betterAdd('page', this.session.pages[i])
      }

      this.detect_events(i)
      this.detect_notification(this.session.pages[i])
      this.detect_cart_change()
      this.detect_segment_change()
      this.detect_offer_change()
      this.detect_ab_change(i)

      this.last_page = this.session.pages[i]
    }

  }

  detect_events(index) {
    if (this.session.events) {
      const events = _.orderBy(this.session.events, ['pageIndex', 'time', (item) => item.subType === 'afn'], ['asc', 'asc', 'asc'])
      const widgetObjectArray = []
      for (const event of events) {
        const pageIndex = event.pageIndex - 1
        const type = event.type
        const subType = event.subType
        if (pageIndex === index && type === 'widget') {
          if (subType !== 'afn') {
            const widget = this.widgets && this.widgets.find(w => w.id === event.data.widgetId)
            const foundWidget = widgetObjectArray.find(w => w.widget.id === event.data.widgetId)
            if (!foundWidget) {
              widgetObjectArray.push({
                widget: widget || {id: event.data.widgetId, name: event.data.widgetName},
                subTypes: subType !== 'view' ? [subType] : []
              })
            } else if (subType !== 'view') {
              foundWidget.subTypes.push(subType)
            }
          } else {
            widgetObjectArray[widgetObjectArray.length - 1].subTypes.push(subType)
          }
        }
      }
      widgetObjectArray.forEach((widgetObject) => {
        this.betterAdd('widget', widgetObject)
      })
    }
  }

  detect_notification(page) {
    const webPush = this.parseWebPushNotification(page.refPage);
    if (webPush) {
      const id = webPush.webPushNotificationId
      if (this.notificationDefs[id]) {
        const def = this.notificationDefs[id]
        const action = webPush.webPushNotificationAction
        this.betterAdd('notification', {
          ...def,
          action
        })
      }
    }
  }

  detect_cart_change() {

    // Item quantity changes.
    let [itemQuantityChange, prev_qty, curr_qty] = this.did_change('itemQuantity')
    if (itemQuantityChange) {
      curr_qty = curr_qty ? curr_qty : 0
      prev_qty = prev_qty ? prev_qty : 0
    }

    // Sub total changes.
    let [subTotalChange, prev_total, curr_total] = this.did_change('subTotal')
    if (subTotalChange) {
      curr_total = curr_total ? curr_total : 0;
      prev_total = prev_total ? prev_total : 0;
    }

    if (itemQuantityChange || subTotalChange) {
      if ((curr_qty - prev_qty) || prev_total || curr_total) {
        this.betterAdd('cart', {
          diff: curr_qty - prev_qty,
          currQuantity: curr_qty, 
          prevQuantity: prev_qty,
          prevTotalValue: prev_total,
          currTotalValue: curr_total
        })
      }
    }

    // Cart coupon code changes.
    let [couponChange, last, current] = this.did_change('couponCode')
    if (couponChange) {
      if (!current && last) {
        this.betterAdd('coupon', {
          removed: true, 
          couponCode: last
        })
      } else if (current) {
        this.betterAdd('coupon', {
          removed: false,
          couponCode: current
        })
      }
    }
  }

  // probably a dumb way to do this
  did_change (var_name) {
    let result = false;
    let last = null
    let current = null

    if (this.last_page === null) {
      last    = null;
      current = this.current_page[var_name];
      result  = true;
    } else {
      last    = this.last_page[var_name];
      current = this.current_page[var_name];
      result = last !== current;
    }

    return [result, last, current];
  }

  detect_segment_change() {
    const segment_ids = this.current_page.segmentIds ? this.current_page.segmentIds.split(',') : []
    // console.log(segment_ids)
    const segments = []

    for (const id of segment_ids) {
      const trimmedId = id.trim()
      if (trimmedId) {
        if (this.segments && this.segments.length) {
          const seg = this.segments.find(s => s.id === parseInt(trimmedId))
          if (seg && seg.name) {
            segments.push(seg)
          } else {
            segments.push({
              id: parseInt(trimmedId)
            })
          }
        } else {
          segments.push({
            id: parseInt(trimmedId)
          })
        }
        this.total_matched_segments++;
      }
    }

    if (segments.length) {
      this.betterAdd('segments', segments)
    }
  }

  detect_offer_change () {
    let presented_id = null
    let collected_id = null
    let offer_id = null
    let svStatus = ''

    const presentedDidChange = this.did_change('presentedIncentiveId')
    const presentedChange = presentedDidChange[0]
    const pres_curr_id = presentedDidChange[2]
    if (presentedChange) {
      presented_id = pres_curr_id
    }

    const collDidChange = this.did_change('collectedIncentiveId')
    const collectedChange = collDidChange[0]
    const coll_curr_id = collDidChange[2] 
    if (collectedChange) {
      collected_id = coll_curr_id
    }

    if ( presented_id && collected_id === presented_id ) {
      offer_id = collected_id
      svStatus   = 'presentedCollected'
    } else if (presented_id) {
      offer_id = presented_id
      svStatus   = 'presented'
    } else if (collected_id) {
      offer_id = collected_id
      svStatus   = 'collected'
    }

    if ( presented_id || collected_id ) {
      const inc = this.incentives.find(i => i.id === offer_id)
      this.betterAdd('offer', {
        ...inc,
        svStatus
      })
    }
  }

  detect_ab_change (index) {
    const ab = this.session.omittedByAbTest;

    if (ab !== null && this.ab_page_index === index) {
      this.betterAdd('ab', {
        status: ab ? 'control' : 'targeted'
      })
    }
  }

  parseWebPushNotification(url) {
    const sourceRE = /\bfp_src=webPush\b/;
		const idRE = /\bfp_id=(\d+)/;
		const actionRE = /\bfp_action=([^&]+)/;
		if (url.match(sourceRE)) {
			return {
				source: 'web-push-notification',
				sourceType: 'notification',
				webPushNotificationId: url.match(idRE) ? url.match(idRE)[1] : null,
				webPushNotificationAction: url.match(actionRE) ? this.urldecode(url.match(actionRE)[1]) : null
			};
		}
		return null;
  }

  betterAdd(type, value) {
    this.last_added_index = this.current_page.index;
    if (type === 'page') {
      const timeDiff = this.getTimeDiff(this.current_page.timestamp, this.start_time)
      this.flow.push({
        page: value,
        timeDiff
      })
    }
    if (type === 'order') {
      const timeDiff = this.getTimeDiff(this.current_page.timestamp, this.start_time)
      this.flow.push({
        order: value.order,
        page: value.page,
        timeDiff
      })
    }
    if (type === 'widget') {
      if (!this.flow[this.last_added_index].widgets) {
        this.flow[this.last_added_index].widgets = []
      }
      this.flow[this.last_added_index].widgets.push(value)
    }
    if (type === 'notification') {
      this.flow[this.last_added_index].notification = value
    }
    if (type === 'cart') {
      this.flow[this.last_added_index].cart = value
    }
    if (type === 'coupon') {
      this.flow[this.last_added_index].coupon = value
    }
    // handled differently from widget array for some reason
    if (type === 'segments') {
      this.flow[this.last_added_index].segments = [...value]
    }
    if (type === 'offer') {
      this.flow[this.last_added_index].offer = value
    }
    if (type === 'ab') {
      this.flow[this.last_added_index].ab = value
    }
  }
  
  is_order_reset_page(page) {
    return page.pageType === 'orderReset' ||
      (page.pageType === 'checkout' && page.refPage === '')
  }


  hx_date_to_mysql_date(time) {
    if (time && time.__t) {
      const date = window.moment(time.__t * 1000)
      return date
              .utcOffset(this.session.timeZone)
              .tz(this.accountTimezone)
              .format('YYYY-MM-DD HH:mm:ss')
    }
    return ''
  }

  urldecode(url) {
    return decodeURIComponent(url.replace(/\+/g, ' '));
  }

  getTimeDiff(x, y) {
    return window.moment.utc(window.moment(x).diff(window.moment(y))).format("HH:mm:ss")
  }
}